import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0996c63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "child-title" }

import { isMobile } from "@/utils/helpers";
import { computed } from "vue";
import { useStore } from "vuex";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { logoutSuccessSnackbar } from "@/utils/snackbars";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNav',
  setup(__props) {

const router = useRouter();
const clickOnButton = (p: any) => {
  if (p && p.meta && p.meta.logout) {
    handleLogout();
  }
}
const mainMenu = [{
        id: 1,
        icon: "mdi mdi-format-list-checkbox",
        title: "Заказы",
        path: { path: '/', permission: null  },
        badge: 0
      },
      { id: 2, icon: "mdi mdi-calendar", title: "Календарь", path: { path: "/calendar" }, permission: null },
      { id: 3, icon: "mdi mdi-calendar-clock", title: "Смены", path: { path: '/shifts' }, permission: null  },
      { id: 4, icon: "mdi mdi-currency-usd", title: "Цены", badge: 0, path: { path: '/prices' }, permission: null },
      {
        id: 5,
        icon: "mdi mdi-cog",
        title: "Настройки",
        permission: null,
        childs: [
          { id: 501, icon: "mdi mdi-account-multiple", title: "Сотр.", path: { path: "/users" }, permission: "create_user" },
          { id: 502, icon: "mdi mdi-account-multiple-outline", title: "Клиенты", path: { path: "/clients" }, permission: "create_clients" },
          { id: 503, icon: "mdi mdi-home-city", title: "Завед.", path: { path: "/offices" }, permission: "create_offices" },
          { id: 504, icon: "mdi mdi-sofa", title: "Лофты", path: { path: "/lofts" } , permission: "create_lofts"},
          { id: 505, icon: "mdi mdi-shopping", title: "Товары", path: { path: "/services" }, permission: "create_services" },
          { id: 506, icon: "mdi mdi-logout", title: "Выйти", meta: { logout: true }, permission: null }
        ],
      }]
const userPermissions = computed(() => store.getters["auth/selectUserPermissions"]);

const generatedUserMenu = computed(() => {
  if (!userPermissions.value) return [];
  return mainMenu.map((menuItem) => {
    if (menuItem.childs) {
      menuItem.childs = menuItem.childs.filter((child: any) => {
        if (!child.permission) return true;
        if (!userPermissions.value) return false;
        return userPermissions.value.includes(child.permission || "");
      });
    }
    return menuItem
  }).filter((menuItem) => {
    if (!menuItem.permission) return true;
    if (!userPermissions.value) return false;
    return userPermissions.value.includes(menuItem.permission || "");
  });
});
const store = useStore();
const selectedPage = ref(1);
const handleLogout = async () => {
  const response = await Promise.resolve(store.dispatch("auth/logout"));
  if (response && response.status ==  "success"){
    logoutSuccessSnackbar();
    router.push({ path: "login" });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_CurvedBottomNavigation = _resolveComponent("CurvedBottomNavigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_bottom_navigation, {
      style: {"z-index":"1"},
      class: "d-block d-sm-none"
    }),
    _createVNode(_component_CurvedBottomNavigation, {
      class: "d-flex d-sm-none mobilenav",
      "foreground-color": "#028179",
      options: generatedUserMenu.value,
      modelValue: selectedPage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPage).value = $event))
    }, {
      "child-icon": _withCtx(({ props }) => [
        _createVNode(_component_v_icon, {
          class: "child-icon",
          onClick: ($event: any) => (clickOnButton(props))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.icon), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      "child-title": _withCtx(({ props }) => [
        _createElementVNode("b", _hoisted_1, _toDisplayString(props.title), 1)
      ]),
      _: 1
    }, 8, ["options", "modelValue"])
  ], 64))
}
}

})